import { NgModule } from '@angular/core';
import { CmsConfig, provideConfig } from '@spartacus/core';

@NgModule({
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        priceFiles: {
          module: () => import('./container/cms-price-files.module').then((m) => m.CmsPriceFilesModule),
          cmsComponents: ['CmsPriceFilesComponent'],
        },
      },
    }),
  ],
})
export class PriceFilesFeatureModule {}
